import { motion } from "framer-motion";
import { ArrowRight, Star } from "lucide-react";
import { REVIEWS } from "./homeData";

const Stars = ({ size = "w-4 h-4" }) => (
  <div className="flex gap-0.5" aria-label="5 out of 5 stars">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} className={`${size} fill-yellow-400 text-yellow-400`} />)}
  </div>
);

export const ReviewsSection = () => (
  <section className="relative py-24 md:py-32 bg-dream-bg overflow-hidden" data-testid="google-reviews">
    <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-16 items-start relative">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="lg:sticky lg:top-28">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-yellow-400 mb-4">Verified Google Reviews</p>
        <p className="font-heading text-8xl md:text-9xl font-extrabold text-white leading-none">5.0</p>
        <div className="mt-4"><Stars size="w-6 h-6" /></div>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mt-6 tracking-tight">Loved by Melbourne&apos;s artists.</h2>
        <p className="text-white/55 mt-3">A perfect rating across 11 Google reviews from real artists, producers &amp; DJs.</p>
        <a href="https://share.google/mA65iCStXRVV4yZ3y" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-8 px-5 py-3 rounded-full bg-white/[0.04] border border-white/10 hover:border-yellow-400/40 transition-colors group" data-testid="see-all-reviews-btn">
          <span className="text-white/85 text-sm font-medium">See all 11 reviews on Google</span>
          <ArrowRight className="w-4 h-4 text-yellow-400 group-hover:translate-x-1 transition-transform" />
        </a>
      </motion.div>
      <div className="grid gap-5">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className={`p-8 rounded-3xl bg-white/[0.03] border border-white/10 hover:border-yellow-400/30 transition-colors ${i === 1 ? "lg:ml-12" : ""}`}
            data-testid={`review-card-${i}`}
          >
            <Stars />
            <blockquote className="font-heading text-xl md:text-2xl text-white/90 leading-snug mt-5">&ldquo;{r.quote}&rdquo;</blockquote>
            <figcaption className="flex items-center gap-3 mt-6">
              <span className={`w-11 h-11 rounded-full bg-gradient-to-br ${r.accent} flex items-center justify-center text-white font-bold text-sm`}>{r.initials}</span>
              <span>
                <span className="block text-white font-semibold text-sm">{r.name}</span>
                <span className="block text-white/40 text-xs">Verified · Google Review</span>
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
